<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Smart Number'"
      [canGoBack]="true"
      [customBack]="(fromGettingStarted || cameFromSubscribePage) ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (isLoading) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    } @else {
      @if (proNumber) {
        <tidy-row>
          <tidy-text
            [body]="'Save the numbers below to share with your pros and guests:'" />
        </tidy-row>
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'Pro Smart Number'" />
          </tidy-row>
          <div class="proxy-copy-row">
            <div>
              <tidy-text class="proxy-number" [header]="proNumber" />
            </div>
            <div>
              <img
                class="proxy-copy-icon"
                src="assets/icon/copy-circle-black.svg"
                (click)="copyToClipboard(proNumber)" />
            </div>
          </div>
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'How Pro Numbers Work'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'1. Share this with pros who you want to be able to message in.'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'2. As pros message in, they come into your Messages section.'" />
          </tidy-row>
        </tidy-card>
      }

      @if (guestNumber) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'Guest Smart Number'" />
          </tidy-row>
          <div class="proxy-copy-row">
            <div>
              <tidy-text class="proxy-number" [header]="guestNumber" />
            </div>
            <div>
              <img
                class="proxy-copy-icon"
                src="assets/icon/copy-circle-black.svg"
                (click)="copyToClipboard(guestNumber)" />
            </div>
          </div>
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'How Guest Numbers Work'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'1. Share this with guests, tenants, or anyone you want to be able message in.'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'2. As guests message in, they come into your Messages section.'" />
          </tidy-row>
        </tidy-card>
      }
    }

    @if (!isLoading && (proNumber || guestNumber)) {
      <tidy-button
        [text]="'Complete Step'"
        [action]="completeStep"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
